import React from 'react'
import { Image } from '@shared/components/image'
import cn from 'classnames'
import { useMedia } from 'use-media'

import { Back } from '../Back'

import styles from './styles.module.scss'

const LoanRepayments = () => {
	const isTablet = useMedia({ minWidth: '768px' })

	return (
		<article className={styles.article}>
			<Back />
			<h1 className={styles.heading}>Оплата и погашение кредита</h1>

			<nav className={styles.nav}>
				<ul>
					<li className={styles.navItem}>
						<a className={styles.link} href='#info'>
							Где смотреть информацию по кредиту?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#payment'>
							Как производить оплату по кредиту?{' '}
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#commission'>
							Есть ли комиссия за платежи?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#early-payment'>
							Возможно ли частично-досрочное и полное погашение в любой момент?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#goodbye-encumbrance'>
							Когда и как снимается обременение?
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#end-documents'>
							Как получить справку о полном погашении кредита?
						</a>
					</li>
				</ul>
			</nav>

			<h3 id='info' className={styles.title}>
				Где смотреть информацию по кредиту?
			</h3>
			<p className={styles.paragraph}>
				Можно зайти в личный кабинет заёмщика. В нём хранится вся информация по кредиту, включая
				пакет документов:
			</p>

			<Image
				name={isTablet ? 'screenshot-t.jpg' : 'screenshot-m.png'}
				alt='Скриншот личного кабинета'
			/>

			<p className={styles.paragraph}>
				Второй вариант — посмотреть сведения о кредите в печатном варианте договора.
			</p>

			<h3 id='payment' className={styles.title}>
				Как производить оплату по кредиту?
			</h3>

			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				Оплатить кредит можно двумя способами:{' '}
			</p>
			<ul>
				<li>
					<p className={styles.paragraph}>
						{' '}
						Быстро — через QR-код. Для этого нужно зайти в личный кабинет заёмщика и нажать на
						кнопку «Оплатить» в разделе «Главная» — появится QR-код для оплаты. Клиенту останется
						только отсканировать его через мобильное приложение своего банка и внести нужную сумму.
					</p>
					<Image
						name={isTablet ? 'payment-t.jpg' : 'payment-m.png'}
						alt='Скриншот платежа в личном кабинете'
					/>
				</li>
				<li>
					<p className={styles.paragraph}>
						Чуть медленнее — по реквизитам. Они будут отображаться чуть ниже QR-кода. Если нужно,
						наш менеджер продублирует вам реквизиты через мессенджеры.
					</p>
					<Image
						name={isTablet ? 'requisites-t.jpg' : 'requisites-m.png'}
						alt='Скриншот реквизитов платежа'
					/>
				</li>
			</ul>
			<p className={styles.paragraph}>
				Внести деньги можно через мобильное приложение или кассу банка. Чтобы избежать возможных
				технических просрочек при переводах, производить оплату лучше всего за 2–3 рабочих дня до
				установленного срока.
			</p>

			<h3 id='commission' className={styles.title}>
				Есть ли комиссия за платежи?
			</h3>
			<p className={styles.paragraph}>
				Это зависит от банка, через который отправляются деньги. Например, без комиссии можно внести
				платежи через Сбербанк, Тинькофф Банк, Альфа-Банк или банк Открытие. В этом списке могут
				быть и другие компании — уточняйте о комиссии у своего банка.
			</p>
			<h3 id='early-payment' className={styles.title}>
				Возможно ли частично-досрочное и полное погашение в любой момент?{' '}
			</h3>

			<p className={styles.paragraph}>
				<b>Частично-досрочное погашения долга.</b>Производить можно раз в месяц. Для этого нужно
				запросить бланк заявления у менеджера, подписать его и отправить нам скан. Лучше всего
				оформлять документ за 2–3 рабочих дня до крайней даты платежа.
			</p>
			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				<b>Полное досрочное погашения кредита.</b>
				Его можно сделать в любое время. Процесс простой:
			</p>
			<ul className={styles.list}>
				<li className={styles.item}>— получить шаблон заявления у менеджера;</li>
				<li className={styles.item}>— подписать и отправить скан или фото документа;</li>
				<li className={styles.item}>
					— запросить расчётный счет для полного погашения кредита у менеджера;
				</li>
				<li className={styles.item}>— внести деньги, чтобы погасить долг.</li>
			</ul>

			<h3 id='goodbye-encumbrance' className={styles.title}>
				Когда и как снимается обременение?
			</h3>
			<p className={styles.paragraph}>
				Обременение снимается после возврата заёмных денег. Когда заёмщик вносит последний платёж и
				мы видим поступление денег на нашем счёте, составляем заявление на погашение обременения и
				отправляем его в Росреестр. Обычно обременение снимается в течение 3 рабочих дней. Скорость
				зависит от загруженности сотрудников государственного органа.
			</p>
			<p className={styles.paragraph}>
				Как только мы видим, что обременение снято, звоним или пишем клиенту в мессенджеры.{' '}
			</p>

			<h3 id='end-documents' className={styles.title}>
				Как получить справку о полном погашении кредита?
			</h3>
			<p className={styles.paragraph}>
				После того, как заёмщик погашает кредит, мы готовим справку о полном погашении долга.
				Отправляем её по электронной почте, в WhatsApp или заказным письмом, если нужен оригинал.
			</p>
		</article>
	)
}

export default LoanRepayments
